import React, { useEffect, useRef, useState } from 'react';
import { Button, Text } from '@fragments';
import { IconBulb, IconStarFilled, IconUpload } from '@tabler/icons-react';
import { ImageGrid } from '../../../../features/ArtEditor';
import { orientationOf, photoTip } from '../../format';
import './styles.scss';

// The creator's own photo, first and recommended (2.12.0): real photos keep the profile
// authentic, ahead of the gallery and AI. It says how the photo should look (the AI's
// `photo_tip`, else a generic tip) and the shape the place asks for, sends one ("Enviar
// foto", which goes in the place), and lists the creator's images the AI found for it.
export default function OwnPhoto({ t, place, suggested, selectedId, onPick, onUpload }) {
  const [state, setState] = useState({ busy: false, failed: false });
  const input = useRef(null);
  const alive = useRef(true);
  useEffect(() => () => { alive.current = false; }, []);
  // Another place starts clean: a failure belonged to the previous one.
  useEffect(() => { setState({ busy: false, failed: false }); }, [place.slot_id]);
  const send = async files => {
    setState({ busy: true, failed: false });
    try {
      await onUpload(files);
      if (alive.current) setState({ busy: false, failed: false });
    } catch {
      if (alive.current) setState({ busy: false, failed: true });
    }
  };
  return <section className="studio-own-photo" aria-labelledby="studio-own-photo-title">
    <div className="studio-own-photo__head">
      <span className="studio-own-photo__badge"><IconStarFilled aria-hidden="true" />{t('imagesOwnBadge')}</span>
      <Text.label id="studio-own-photo-title" weight={600} contrast={9}>{t('imagesOwnTitle')}</Text.label>
      <Text.caption contrast={6}>{t('imagesOwnWhy')}</Text.caption>
    </div>
    <div className="studio-own-photo__tip">
      <IconBulb aria-hidden="true" />
      <div className="studio-own-photo__tip-text">
        <Text.caption contrast={6}>{`${t('imagesOwnTip')} · ${t(`imagesOrientation_${orientationOf(place.box)}`)}`}</Text.caption>
        <Text.p contrast={9}>{photoTip(t, place)}</Text.p>
      </div>
    </div>
    <input ref={input} type="file" accept="image/png,image/jpeg,image/webp" hidden
      onChange={event => { const files = [...event.target.files]; event.target.value = ''; if (files.length) send(files.slice(0, 1)); }} />
    <div className="studio-own-photo__actions">
      <Button variant="rounded" color="inverse" startIcon={<IconUpload />} loading={state.busy} disabled={state.busy} preventLoading
        onClick={() => input.current?.click()}>{t('imagesOwnUpload')}</Button>
      {state.failed && <Text.caption contrast={8} role="alert">{t('imagesOwnUploadFailed')}</Text.caption>}
    </div>
    {suggested.length > 0 && <div className="studio-own-photo__suggested">
      <Text.caption contrast={6}>{t('imagesSuggestedHint')}</Text.caption>
      <ImageGrid items={suggested} selectedId={selectedId ?? null} onPick={onPick} columns={4} label={t('imagesSuggested')} pickLabel={t('imagesPick')} />
    </div>}
  </section>;
}
